// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"search_searchBarContainer__qN+7C","searchInputField":"search_searchInputField__xjjf6","searchSugeestionsWrapper":"search_searchSugeestionsWrapper__Y-YnB"};